<template>
	<div>
		<h6 class="hidden md:block text-sm text-dj-grey leading-[48px] mb-2 mt-2">
			{{ $t("footer.follow") }}
		</h6>

		<div class="flex flex-wrap items-center mt-4 md:mt-0 gap-8 md:gap-4 mb-6">
			<a
				v-if="socialLinks.facebook"
				:href="socialLinks.facebook"
				target="_blank"
				aria-label="Facebook"
				class="hover:opacity-80 transition-opacity"
			>
				<BaseIcon icon="logos:facebook" class="w-10 h-10 md:w-8 md:h-8" />
			</a>
			<a
				v-if="socialLinks.instagram"
				:href="socialLinks.instagram"
				target="_blank"
				aria-label="Instagram"
				class="hover:opacity-80 transition-opacity"
			>
				<BaseIcon icon="skill-icons:instagram" class="w-10 h-10 md:w-8 md:h-8" />
			</a>
			<a
				v-if="socialLinks.linkedin"
				:href="socialLinks.linkedin"
				target="_blank"
				aria-label="LinkedIn"
				class="hover:opacity-80 transition-opacity"
			>
				<BaseIcon icon="logos:linkedin-icon" class="w-10 h-10 md:w-8 md:h-8" />
			</a>

			<a
				v-if="socialLinks.tiktok"
				:href="socialLinks.tiktok"
				target="_blank"
				aria-label="TikTok"
				class="hover:opacity-80 transition-opacity"
			>
				<BaseIcon icon="logos:tiktok-icon" class="w-10 h-10 md:w-8 md:h-8" />
			</a>
			<a
				v-if="socialLinks.spotify"
				:href="socialLinks.spotify"
				target="_blank"
				aria-label="Spotify"
				class="hover:opacity-80 transition-opacity"
			>
				<BaseIcon icon="logos:spotify-icon" class="w-10 h-10 md:w-8 md:h-8" />
			</a>
			<a
				v-if="socialLinks.youtube"
				:href="socialLinks.youtube"
				target="_blank"
				aria-label="YouTube"
				class="hover:opacity-80 transition-opacity"
			>
				<BaseIcon icon="logos:youtube-icon" class="w-10 h-10 md:w-8 md:h-8" />
			</a>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "SocialIcons",
	setup() {
		const config = useRuntimeConfig();
		const socialLinks = config.public.socialLinks;

		return {
			socialLinks,
		};
	},
});
</script>
